import { render, staticRenderFns } from "./MainArea.vue?vue&type=template&id=2f8e06ac&scoped=true"
import script from "./MainArea.vue?vue&type=script&lang=js"
export * from "./MainArea.vue?vue&type=script&lang=js"
import style0 from "./MainArea.vue?vue&type=style&index=0&id=2f8e06ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e06ac",
  null
  
)

export default component.exports